// extracted by mini-css-extract-plugin
export default {"container":"LiveVideo_container__x91hr","pagination":"LiveVideo_pagination__Tf9tt"};